export const buildAggQuery = (aris: string[], index: number) => {
	return `
    query GetDocuments {
      ${aris
				.map(
					(ari, i) => `
        doc${index + i + 1}: node(id: \"${ari}\") {
          id
          __typename
          ... on ConfluencePage {
            title
            body {
              atlasDocFormat {
                value
              }
            }
          }
          ... on ConfluenceBlogPost {
            title
            body {
              atlasDocFormat {
                value
              }
            }
          }
          ... on JiraIssue {
            key
            summary
            descriptionField {
              description
            }
          }
        }
      `,
				)
				.join('\n')}
    }
  `;
};
